import React from "react";
import { useDispatch } from "react-redux";
import { actions as appActions } from "../../redux/app";
import { appSelector } from "../../redux/app/selectors";

import {Menu, MenuItem, Fade, Button} from "@mui/material";
import styled from "styled-components";
import Link from "next/link";

const StyledMenu = styled(Menu)`
  && {
    .MuiMenuItem-root {
      font-size: 1.8rem;
      font-weight: 800;
      width: 100%;
      margin: 0.25em 0;
      padding: 0 2rem;
      justify-content: left;
    }
    .MuiMenu-paper {
      position: fixed;
      top: 93px !important;
      left: 0 !important;
      width: 100%;
      height: 100%;
      max-height: 100%;
      max-width: 100%;
      background-color: #252f28;
      color: #fff;
    }
  }
`;
const ButtonGroup = styled.div`
  margin-top: 50px;
`;
const StyledWhiteButton = styled(Button)`
  && {
    background-color: #fff;
    color: #de4a22;
    &:hover {
      background-color: #de4a22;
      color: #fff;
    }
  }
`;
const StyledOrangeButton = styled(Button)`
  && {
    background-color: #de4a22;
    border-color: #de4a22;
    color: #fff;
    &:hover {
      background-color: #fff;
      color: #de4a22;
    }
  }
`;
const MobileMenu = ({ anchorEl, handleClose, navigation }) => {
  const dispatch = useDispatch();
  const app = appSelector((state) => state.app);
  return (
    <StyledMenu
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      TransitionComponent={Fade}
    >
      {navigation.fields.pageLinks.map((link, index) => (
        <Link href={link.fields.linkUrl} key={index}>
          <span>
            <MenuItem onClick={handleClose}>{link.fields.linkTitle}</MenuItem>
          </span>
        </Link>
      ))}
      <ButtonGroup>
        <MenuItem>
          <StyledWhiteButton
            variant="outlined"
            color="primary"
            fullWidth
            href={`tel:${app.phoneNumber}`}
          >
            Call us
          </StyledWhiteButton>
        </MenuItem>
        <MenuItem>
          <Link href="/contact-us" style={{width:`100%`}}>
            <StyledOrangeButton
              variant="outlined"
              color="primary"
              fullWidth
            >
              Contact us now
            </StyledOrangeButton>
          </Link>
        </MenuItem>
      </ButtonGroup>
    </StyledMenu>
  );
};
export default MobileMenu;
